module.exports = __webpack_public_path__ + "img/clinical-research-logo.715819e1.jpg";